import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'


ExpandIcon.propTypes = {
  isActive: PropTypes.bool,
}

export default function ExpandIcon({
  isActive = false,
}) {
  return <FontAwesomeIcon icon={isActive ? 'minus' : 'plus'} />
}
